import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PluralTranslatePipe } from './plural-translate.pipe';

@NgModule({
  declarations: [PluralTranslatePipe],
  imports: [CommonModule],
  exports: [PluralTranslatePipe],
})
export class PluralTranslatePipeModule {}
